import { atom } from "jotai";

export const isRoleRADAtom = atom(false);